import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';

import deleteDialog from './dialogs/delete-dialog';
import modal, { closeModal, openModal } from './dialogs/modal';
import statusDialog from './dialogs/status-dialog';
import { enhanceBootstrapShims } from './enhance/bootstrap-shims';
import { enhanceColors } from './enhance/colors';
import { enhanceDate, enhanceDates } from './enhance/dates';
import { emailList } from './enhance/email-list';
import { enhanceFiles } from './enhance/files';
import { removeExistingImage, requireEditorText, setFieldError, setSummaryError, toggleWithCheckbox } from './enhance/forms';
import { enhanceSelect, enhanceSelects } from './enhance/selects';
import { enhanceValidation, requireOne } from './enhance/validation';
import { getJson, handleResult, postForm, postHtml, postQuery, reloadSoon, setHtml } from './http';
import { applicationDialog } from './pages/applications';
import { articleDialog } from './pages/articles';
import { applicationMode } from './pages/jobs';
import { productRow } from './pages/products';
import { contactAdmins } from './pages/recruiters';
import { subscriptionDates } from './pages/subscriptions';
import shell from './shell';
import toasts from './toasts';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus);

Alpine.data('shell', shell);
Alpine.data('modal', modal);
Alpine.data('statusDialog', statusDialog);
Alpine.data('deleteDialog', deleteDialog);
Alpine.data('applicationDialog', applicationDialog);
Alpine.data('articleDialog', articleDialog);
Alpine.data('productRow', productRow);
Alpine.data('contactAdmins', contactAdmins);
toasts(Alpine);

// For the page scripts in wwwroot/js/custom and inline view scripts (run them
// on DOMContentLoaded, after this bundle).
window.admin = {
  applicationMode,
  closeModal,
  emailList,
  enhanceDate,
  enhanceSelect,
  getJson,
  handleResult,
  openModal,
  postForm,
  postHtml,
  postQuery,
  removeExistingImage,
  requireEditorText,
  requireOne,
  setFieldError,
  setHtml,
  setSummaryError,
  subscriptionDates,
  toggleWithCheckbox,
};
window.refreshPage = reloadSoon;

enhanceBootstrapShims();
enhanceSelects();
enhanceDates();
enhanceFiles();
enhanceColors();
enhanceValidation();

Alpine.start();
